const drawDot = (ctx, path, stormPoint, color = '#fff') => {
  ctx.beginPath();
  path(stormPoint);
  ctx.fillStyle = color;
  ctx.fill();
};

export { drawDot };
